import { tryParseJsonText, toStringFqn } from 'app/lib/utils';
import { TypeFamily } from 'app/lib/types/server';

export const transformSnowflakeResponse = ({ columns, valuesByColumn }) => {
    const result = [];
    for (let i = 0; i < valuesByColumn[0].length; i++) {
        const obj = {};
        for (let j = 0; j < valuesByColumn.length; j++) {
            const name = columns[j].name;
            obj[name] = valuesByColumn[j][i];
        }
        result.push(obj);
    }

    return result;
};

export const transformSnowflakeRolesResponse = ({ valuesByColumn }) => ({
    currentRole: valuesByColumn[0][0],
    availableRoles: tryParseJsonText(valuesByColumn[1])
});

export const getTypeFamily = (typeInfo) => {
    const parsedTypeInfo = tryParseJsonText(typeInfo);
    const type = parsedTypeInfo?.type;
    const scale = parsedTypeInfo?.scale;
    switch (type) {
        case 'TEXT':
            return TypeFamily.STRING;
        case 'FIXED':
            return scale > 0 ? TypeFamily.DOUBLE : TypeFamily.INTEGER;
        case 'REAL':
            return TypeFamily.DOUBLE;
        case 'DATETIME':
            return TypeFamily.TIMESTAMP;
        default:
            if (type.startsWith('TIMESTAMP')) {
                return TypeFamily.TIMESTAMP;
            }
            return type;
    }
};

export const transformSnowflakeSearchResults = (payload) => {
    const snowflakeObjects = tryParseJsonText(payload);
    const databases = {};
    const schemas = {};
    snowflakeObjects?.forEach((entry) => {
        const { domain, database, schema, name } = entry;
        if (!['DATABASE', 'SCHEMA', 'TABLE', 'VIEW'].includes(domain)) {
            return;
        }
        databases[database] = { name: database, isLoading: false };
        const schemaFqn = toStringFqn({ database, schema });
        if (['SCHEMA', 'TABLE', 'VIEW'].includes(domain) && !schemas.hasOwnProperty(schemaFqn)) {
            schemas[schemaFqn] = { database, schema, fqn: schemaFqn, sources: {} };
        }
        if (domain === 'VIEW' || domain === 'TABLE') {
            const sourceFqn = toStringFqn({ database, schema, table: name });
            schemas[schemaFqn].sources = {
                ...schemas[schemaFqn].sources,
                [sourceFqn]: {
                    database,
                    schema,
                    table: name,
                    sourceType: domain,
                    fqn: sourceFqn
                }
            };
        }
    });
    return { databases, schemas };
};

export const transformSnowflakeSearchResultsDestination = (payload) => {
    const snowflakeObjects = tryParseJsonText(payload);
    const databases = {};
    let schemas = [];
    snowflakeObjects?.forEach((entry) => {
        const { domain, database, schema } = entry;
        if (!['DATABASE', 'SCHEMA', 'TABLE', 'VIEW'].includes(domain)) {
            return;
        }
        databases[database] = { name: database, isLoading: false };
        const schemaFqn = toStringFqn({ database, schema });
        if (domain === 'SCHEMA' && !schemas.hasOwnProperty(schemaFqn)) {
            schemas = [...schemas, { database, schema, fqn: schemaFqn }];
        }
    });
    return { databases, schemas };
};
